import { selectedPhotoAtom } from '@js/store/orderPageAtoms';
import { useAtom } from '@store';
import { ChangeEvent, useState } from 'react';
import CameraIcon from '@images/svg/camera.svg?react';
import { useTranslation } from 'react-i18next';
import AddPhotoPreviewModal, {
    initialAddPhotoPreviewModalState,
} from '@components/features/photos/AddPhotoPreviewModal';
import { useParams } from 'react-router';
import { resizeImage } from '@utils/imageUtils';

const CameraUploadInput = () => {
    const [, setSelectedPhoto] = useAtom(selectedPhotoAtom);
    const { t } = useTranslation();
    const [photoPreviewModalState, setPhotoPreviewModalState] = useState(
        initialAddPhotoPreviewModalState,
    );
    const { orderId } = useParams<{ orderId?: string }>();

    const onPhotoTaken = async (event: ChangeEvent<HTMLInputElement>) => {
        const { files } = event.target;
        const photo = files?.item(0);
        if (!photo) {
            return;
        }

        const resizedPhoto = await resizeImage(photo);
        const photoUrl = window.URL.createObjectURL(resizedPhoto);
        setSelectedPhoto({
            filename: resizedPhoto.name,
            url: photoUrl,
        });
        setPhotoPreviewModalState({
            isOpen: true,
            data: { orderId: orderId ? Number(orderId) : null },
        });
    };

    return (
        <>
            <label htmlFor="camera-upload-input" className="cameraUpload">
                <CameraIcon className="cameraUpload__icon" />
                <div className="cameraUpload__label">
                    {t('camera', { ns: 'navigation' })}
                </div>

                <input
                    id="camera-upload-input"
                    type="file"
                    onChange={onPhotoTaken}
                    accept="image/*"
                    capture="environment"
                    className="cameraUpload__input"
                    value={[]}
                />
            </label>
            <AddPhotoPreviewModal
                modalState={photoPreviewModalState}
                setModalState={setPhotoPreviewModalState}
            />
        </>
    );
};

export default CameraUploadInput;
